import styled from 'styled-components';
import { Field, useForm } from 'react-final-form';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { Box as MuiBox, useTheme } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { isValid, parseISO } from 'date-fns';
import { dateFnsLocales } from 'lib/utils/getDateFnsLocales';

const tryParseISO = (value) => {
  try {
    return parseISO(value);
  } catch (e) {
    return value;
  }
};

const DatePickerComponent = styled((props) => {
  const form = useForm();
  const { t, i18n } = useTranslation();
  const theme = useTheme();

  return (
    <Field name={props.name}>
      {({ input, meta }) => {
        return (
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={dateFnsLocales[i18n.language]}
          >
            <MuiBox display="flex" flexDirection="column">
              {!props.includeTime ? (
                <DatePicker
                  {...input}
                  {...props}
                  onClose={() => {
                    form.blur(props.name);
                    props.onClose && props.onClose();
                  }}
                  value={
                    input.value
                      ? isValid(input.value)
                        ? input.value
                        : tryParseISO(input.value)
                      : null
                  }
                  slotProps={{
                    ...props.slotProps,
                    textField: {
                      ...props.slotProps?.textField,
                      placeholder: props?.placeholder,
                      InputProps: { className: 'input', ...props?.inputProps },
                      sx: {
                        '& fieldset': {
                          '& legend': {
                            width: 'unset',
                          },
                        },
                      },
                      onBlur: (e) => {
                        form.blur(props.name);
                        props.slotProps?.textField?.onBlur &&
                          props.slotProps.textField.onBlur(e);
                      },
                      error: meta.touched && meta.error != null,
                    },
                  }}
                />
              ) : (
                <DateTimePicker
                  {...input}
                  {...props}
                  onClose={() => {
                    form.blur(props.name);
                    props.onClose && props.onClose();
                  }}
                  value={
                    input.value
                      ? isValid(input.value)
                        ? input.value
                        : tryParseISO(input.value)
                      : null
                  }
                  slotProps={{
                    ...props.slotProps,
                    textField: {
                      ...props.slotProps?.textField,
                      placeholder: props?.placeholder,
                      InputProps: { className: 'input', ...props?.inputProps },
                      sx: {
                        '& fieldset': {
                          '& legend': {
                            width: 'unset',
                          },
                        },
                      },
                      onBlur: (e) => {
                        form.blur(props.name);
                        props.slotProps?.textField?.onBlur &&
                          props.slotProps.textField.onBlur(e);
                      },
                      error: meta.touched && meta.error != null,
                    },
                  }}
                />
              )}
              <div
                style={{
                  marginTop: 5,
                  color: theme.palette.colors.red100,
                  fontSize: 12,
                  fontWeight: 400,
                }}
              >
                {meta.touched && t(meta.error)}
              </div>
            </MuiBox>
          </LocalizationProvider>
        );
      }}
    </Field>
  );
})``;

export default DatePickerComponent;
